'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var classNames = require('classnames');
var React = require('react');
var withStyles = require('../../node_modules/@material-ui/core/styles/withStyles.js');
require('prop-types');
var imageGallery = require('../../node_modules/react-image-gallery/build/image-gallery.js');
var CarouselStyles = require('./CarouselStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var styles = {
  thumbnail: {
    width: '100px',
    height: '100px'
  },
  thumbnailImg: {
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%'
  },
  preview: {
    width: '100%',
    position: 'relative',
    paddingTop: '20%'
  },
  previewAspectRatio2: {
    paddingTop: '25%'
  },
  previewImg: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  previewImgAspectRatio2: {
    width: 'auto !important',
    height: '100%',
    margin: 'auto'
  }
};

var ImageCarousel =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ImageCarousel, _PureComponent);

  function ImageCarousel(props) {
    var _this;

    classCallCheck(this, ImageCarousel);

    _this = possibleConstructorReturn(this, getPrototypeOf(ImageCarousel).call(this, props));
    _this.imageGalleryRef = React__default["default"].createRef();
    return _this;
  }

  createClass(ImageCarousel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.imageGalleryRef.current.slideToIndex(this.props.startIndex);
    }
  }, {
    key: "decorateImageList",
    value: function decorateImageList(imageUrlList) {
      var _this2 = this;

      var aspectRatioClass = this.props.classes["previewAspectRatio".concat(this.props.aspectRatio)];
      return imageUrlList.map(function (item) {
        var url = item.original_url;
        var fileName = !!url ? url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.')) : 'image';
        return _objectSpread({}, item, {
          bulletOnClick: _this2.props.onSelectBullet,
          thumbnailClass: _this2.props.classes.thumbnail,
          originalClass: classNames__default["default"](_this2.props.classes.preview, defineProperty({}, aspectRatioClass, !!aspectRatioClass)),
          originalAlt: fileName,
          thumbnailAlt: fileName
        });
      });
    }
  }, {
    key: "renderThumbnailImg",
    value: function renderThumbnailImg(item) {
      return React__default["default"].createElement("div", {
        style: {
          backgroundImage: "url('".concat(item.thumb_url, "')")
        },
        className: this.props.classes.thumbnailImg
      });
    }
  }, {
    key: "renderPreviewImg",
    value: function renderPreviewImg(item) {
      var aspectRatioClass = this.props.classes["previewImgAspectRatio".concat(this.props.aspectRatio)];
      return React__default["default"].createElement("img", {
        src: item.original_url,
        alt: item.originalAlt,
        className: classNames__default["default"](this.props.classes.previewImg, defineProperty({}, aspectRatioClass, !!aspectRatioClass))
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          imageUrlList = _this$props.imageUrlList,
          startIndex = _this$props.startIndex,
          onSelect = _this$props.onSelect;
      var decoratedImageList = this.decorateImageList(imageUrlList);
      return React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement(imageGallery, {
        ref: this.imageGalleryRef,
        items: decoratedImageList,
        showFullscreenButton: false,
        showPlayButton: false,
        showBullets: true,
        startIndex: startIndex,
        renderThumbInner: function renderThumbInner(item) {
          return _this3.renderThumbnailImg(item);
        },
        renderItem: function renderItem(item) {
          return _this3.renderPreviewImg(item);
        },
        onThumbnailClick: function onThumbnailClick(event, index) {
          return onSelect(event, index);
        }
      }), React__default["default"].createElement(CarouselStyles, null));
    }
  }]);

  return ImageCarousel;
}(React.PureComponent);

ImageCarousel.defaultProps = {
  imageUrlList: [],
  startIndex: 0,
  onSelect: function onSelect() {},
  onSelectBullet: function onSelectBullet() {}
};
var ImageCarousel$1 = withStyles(styles)(ImageCarousel);

module.exports = ImageCarousel$1;
